import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import PageActionBar from 'components/PageActionBar';
import UserFilters from 'components/Filters/UserFilters';
import IQMList from './IQMList';
import IQMDetails from './IQMDetails';
import IQMNew from './IQMNew';
import IQMEdit from './IQMEdit';
import { navigate, setIQMFilters, resetIQMFilters } from 'actionCreators';
import { getRole } from '../../../../reducers';
import ui from 'redux-ui';
import contentAreaStyles from 'styles/contentArea';
import { can } from '../../../../services';

class IQMs extends React.Component {
  constructor(context, props) {
    super(context, props);
    this.toggleFilterDrawer = () => {
      this.setState({ showFilterDrawer: !this.state.showFilterDrawer });
    };
    this.handleFilterChange = filters => this.props.setIQMFilters(filters);
    this.state = {
      showFilterDrawer: false, canViewInactive: can(this.props.role, 'view', 'inactive'),
    };
    this.isIndexRoute = () => this.props.location.pathname === this.props.route.path;
  }

  onSearch = (e, value) => {
    e.preventDefault();
    const filters = { ...this.props.filters };
    filters.query = value;
    this.handleFilterChange(filters);
  }

  addAction = () => this.props.navigate('/iqms/new');

  render = () => {
    const showFiltersDrawer = this.isIndexRoute();
    return (<div>
      <PageActionBar
        resource="iqm"
        role={this.props.role}
        addAction={this.addAction}
        showFiltersBtn={showFiltersDrawer}
        title="IQM Management"
        searchText="Search for an IQM..."
        toggleFilters={this.toggleFilterDrawer}
        onSearch={this.onSearch}
        path={this.props.location.pathname}
      />
      <div className={contentAreaStyles.contentAreaContainer}>
        {this.props.children}
        <UserFilters
          active={this.state.showFilterDrawer}
          onOverlayClick={this.toggleFilterDrawer}
          handleFilterChange={this.handleFilterChange}
          filters={this.props.filters}
          title="IQMs"
          reset={this.props.resetIQMFilters}
          role={this.props.role}
          resource="iqm"
        />
      </div>
    </div>);
  }
}

IQMs.propTypes = {
  setIQMFilters: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  route: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  role: PropTypes.string,
  navigate: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  resetIQMFilters: PropTypes.func.isRequired,
  filters: PropTypes.object,
};

const mapStateToProps = state => ({
  role: getRole(state), filters: state.iqms.filters.data,
});

export default ui({ key: 'iqms', state: { successMessage: '', activeTab: 0 } })(connect(
  mapStateToProps, { navigate, setIQMFilters, resetIQMFilters },
)(IQMs));

export { IQMList, IQMDetails, IQMEdit, IQMNew };



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/iqms/index.jsx